// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/Initial/Ellipse.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.initialPageBdy{
    width: 100vw;
    width: 100svw;
    height: 100vh;
    height: 100svh;
    max-width: 100vw;
    max-width: 100svw;
    max-height: 100vh;
    max-height: 100svh;
    overflow-x: hidden;
    overflow-y: hidden;
}

.initialPage{
    min-height: 100vh;
    background-color: var(--blackMain-color);
    color: var(--blackMain-color);
}

.initialPage .bannerInitial{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    min-height: 95vh;
    background-color: var(--blackMain-color);
    color: var(--whiteMain-color);
    padding-top: 5%;
}

.initialPage .bannerInitial.showBannerText{
    width: 100%;
    height: 100%;
    background-color: var(--blackMain-color);
    color: var(--whiteMain-color);
}

.initialPage .logoBabitanoLoad{
    /* position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%); */
    width: 70%;
    aspect-ratio: 149 / 48;
    transition: top 2s ease-in-out, scale 2s ease-in-out;
}


.initialPage .textSobre{
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1.3em;
    transition: all 3s;
    text-align: center;
    width: 90%;
}

.initialPage .bannerInitial .logoBabitanoLoad.showBannerText{
    top: 57px;
    width: 58%;
}



.initialPage video{
    object-fit: cover;
}


.initialPage .containerLogoBabita{
    z-index: 3;
    margin: 9px 0 0 15px;
}

.initialPage .containerLogoBabita img.logoBabita {
    width: 50%;
    aspect-ratio: 149 / 48;
    font-family: 'Cardo', 'serif';
}

.initialPage .containerLogoBabita .actualYear {
    font-family: 'Cardo', 'serif';
    font-weight: 800;
    color: var(--whiteMain-color);
    text-shadow: -1px 1px 3.4px rgba(0, 0, 0, 0.6);
    font-size: 1.6em;
}


.initialPage .containerBtnExplorar{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 50px;
    align-self: center;
    width: 60px;
    height: 60px;
    z-index: 3;
    color: var(--whiteMain-color);
    font-family: 'Cardo', 'serif';
    font-weight: 800;
    text-shadow: -1px 1px 3.4px rgba(0, 0, 0, 0.6);
    padding: 10px;
}

.initialPage .containerBtnExplorar .btnExplorar{
   z-index: 4;  
}

.initialPage .containerBtnExplorar .elipse{
    position: absolute;
    width: 100%;
    height: 100%;   
    z-index: 3;
}

.initialPage .containerBtnExplorar .elipse.load{
    border: 3px solid var(--whiteMain-color);
    border-radius: 50%; 
    box-shadow: -1px 1px 3.4px rgba(0, 0, 0, 0.6);
}

.initialPage .containerBtnExplorar .elipse.animated{
    animation: rotate 2s linear infinite;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center/contain;
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/initialPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,wCAAwC;IACxC,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;IACI;;;uCAGmC;IACnC,UAAU;IACV,sBAAsB;IACtB,oDAAoD;AACxD;;;AAGA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;;;AAIA;IACI,iBAAiB;AACrB;;;AAGA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,6BAA6B;IAC7B,8CAA8C;IAC9C,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,6BAA6B;IAC7B,6BAA6B;IAC7B,gBAAgB;IAChB,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;GACG,UAAU;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,4EAAuE;AAC3E;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".initialPageBdy{\r\n    width: 100vw;\r\n    width: 100svw;\r\n    height: 100vh;\r\n    height: 100svh;\r\n    max-width: 100vw;\r\n    max-width: 100svw;\r\n    max-height: 100vh;\r\n    max-height: 100svh;\r\n    overflow-x: hidden;\r\n    overflow-y: hidden;\r\n}\r\n\r\n.initialPage{\r\n    min-height: 100vh;\r\n    background-color: var(--blackMain-color);\r\n    color: var(--blackMain-color);\r\n}\r\n\r\n.initialPage .bannerInitial{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    width: 100%;\r\n    min-height: 95vh;\r\n    background-color: var(--blackMain-color);\r\n    color: var(--whiteMain-color);\r\n    padding-top: 5%;\r\n}\r\n\r\n.initialPage .bannerInitial.showBannerText{\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: var(--blackMain-color);\r\n    color: var(--whiteMain-color);\r\n}\r\n\r\n.initialPage .logoBabitanoLoad{\r\n    /* position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%); */\r\n    width: 70%;\r\n    aspect-ratio: 149 / 48;\r\n    transition: top 2s ease-in-out, scale 2s ease-in-out;\r\n}\r\n\r\n\r\n.initialPage .textSobre{\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 700;\r\n    font-size: 1.3em;\r\n    transition: all 3s;\r\n    text-align: center;\r\n    width: 90%;\r\n}\r\n\r\n.initialPage .bannerInitial .logoBabitanoLoad.showBannerText{\r\n    top: 57px;\r\n    width: 58%;\r\n}\r\n\r\n\r\n\r\n.initialPage video{\r\n    object-fit: cover;\r\n}\r\n\r\n\r\n.initialPage .containerLogoBabita{\r\n    z-index: 3;\r\n    margin: 9px 0 0 15px;\r\n}\r\n\r\n.initialPage .containerLogoBabita img.logoBabita {\r\n    width: 50%;\r\n    aspect-ratio: 149 / 48;\r\n    font-family: 'Cardo', 'serif';\r\n}\r\n\r\n.initialPage .containerLogoBabita .actualYear {\r\n    font-family: 'Cardo', 'serif';\r\n    font-weight: 800;\r\n    color: var(--whiteMain-color);\r\n    text-shadow: -1px 1px 3.4px rgba(0, 0, 0, 0.6);\r\n    font-size: 1.6em;\r\n}\r\n\r\n\r\n.initialPage .containerBtnExplorar{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: absolute;\r\n    bottom: 50px;\r\n    align-self: center;\r\n    width: 60px;\r\n    height: 60px;\r\n    z-index: 3;\r\n    color: var(--whiteMain-color);\r\n    font-family: 'Cardo', 'serif';\r\n    font-weight: 800;\r\n    text-shadow: -1px 1px 3.4px rgba(0, 0, 0, 0.6);\r\n    padding: 10px;\r\n}\r\n\r\n.initialPage .containerBtnExplorar .btnExplorar{\r\n   z-index: 4;  \r\n}\r\n\r\n.initialPage .containerBtnExplorar .elipse{\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;   \r\n    z-index: 3;\r\n}\r\n\r\n.initialPage .containerBtnExplorar .elipse.load{\r\n    border: 3px solid var(--whiteMain-color);\r\n    border-radius: 50%; \r\n    box-shadow: -1px 1px 3.4px rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.initialPage .containerBtnExplorar .elipse.animated{\r\n    animation: rotate 2s linear infinite;\r\n    background: url('../imgs/Initial/Ellipse.png') no-repeat center/contain;\r\n}\r\n\r\n@keyframes rotate {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
